import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PrivateGuardService {
	constructor(
		private router: Router,
	) {}

	async canActivate(): Promise<boolean> {
		if (window.location.hostname === environment.publicDomain) {
			// using public domain - deny access
			this.router.navigate(['error/403']);
			return false;
		} else {
			// using private domain - allow access
			return true;
		}
	}
}
